<template>
    <div class="dropup d-inline-block">
        <button ref="solveShortfallsButton" class="btn btn-success dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" :aria-label="mainButtonAriaLabel">
            Solve shortfalls
        </button>
        <ul class="dropdown-menu">
            <li>
                <button class="dropdown-item"
                        @click="$emit('solve-take-less')"
                        :disabled="disableButtons"
                        :aria-label="getSolveButtonAriaLabel(SolveType.TakeLess)">
                    Take less
                </button>
            </li>
            <li>
                <button class="dropdown-item"
                        @click="$emit('solve-pay-more')"
                        :disabled="disableButtons || !hasPensionPots"
                        :aria-label="getSolveButtonAriaLabel(SolveType.PayMore)">
                    Pay more
                </button>
            </li>
            <li>
                <button v-if="equityReleaseEnabled"
                        class="dropdown-item"
                        @click="$emit('solve-equity-release')"
                        :disabled="disableButtons"
                        :aria-label="getSolveButtonAriaLabel(SolveType.EquityRelease)">
                    Home equity
                </button>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { computed, defineEmits, ref } from "vue";
import { useStore } from "vuex";
import ScenarioType from "@/guiide/ts/scenarioType";
import ScenarioInfo from "@/guiide/ts/scenarioInfo";
import SolveType, { getSolveTypeInfo } from "@/guiide/ts/solve/solveType";

defineExpose({ setDisabledState, takeFocus });

const props = defineProps<{
  scenario: ScenarioType
}>();

const emit = defineEmits(["solve-take-less", "solve-pay-more", "solve-equity-release"]);

const store = useStore();

const solveShortfallsButton = ref(null);
const disableButtons = ref(false);

const hasPensionPots = computed<boolean>(() => store.state.retiree?.pensionPots.pots.length > 0);

const equityReleaseEnabled = computed<boolean>(() => store.state.configuration.solveIncludesEquityRelease);

const mainButtonAriaLabel = computed<string>(() => {
  const scenarioName = ScenarioInfo.getName(props.scenario);
  return `Examine ways of solving the shortfall in the '${scenarioName}' scenario.`
});

function getSolveButtonAriaLabel(solveType: SolveType): string {
  const solveTypeInfo = getSolveTypeInfo(solveType);
  return `Check if the shortfall could be solved by ${solveTypeInfo.gerund}.`
}

function setDisabledState(disabled: boolean) {
  this.disableButtons = disabled;
}

function takeFocus(key: string): boolean {
  solveShortfallsButton.value.focus();
  return true;
}
</script>
